// Shared reCAPTCHA v3 token helper.
//
// Waits for the async reCAPTCHA script to finish loading before requesting a
// token, so a fast click on a freshly-opened form no longer loses the "script
// hasn't loaded yet" race. Returns null when reCAPTCHA is genuinely unavailable
// (missing site key, or blocked by an ad-blocker / firewall) — the server fails
// open on a missing token, so null is a safe, non-blocking signal.

const READY_TIMEOUT_MS = 3000
const POLL_INTERVAL_MS = 100

export async function getRecaptchaToken(siteKey, action) {
  if (!siteKey) return null

  const grecaptcha = await waitForRecaptcha()
  if (!grecaptcha) return null

  try {
    return await new Promise((resolve, reject) => {
      grecaptcha.ready(() => grecaptcha.execute(siteKey, { action }).then(resolve).catch(reject))
    })
  } catch {
    return null
  }
}

// Poll for the global to appear rather than giving up on the first miss.
function waitForRecaptcha(timeoutMs = READY_TIMEOUT_MS, intervalMs = POLL_INTERVAL_MS) {
  return new Promise((resolve) => {
    if (typeof window.grecaptcha !== 'undefined') return resolve(window.grecaptcha)

    let waited = 0
    const timer = setInterval(() => {
      if (typeof window.grecaptcha !== 'undefined') {
        clearInterval(timer)
        resolve(window.grecaptcha)
      } else if ((waited += intervalMs) >= timeoutMs) {
        clearInterval(timer)
        resolve(null)
      }
    }, intervalMs)
  })
}
